import { SYNC_KEY_CATALOGOS_PLAGAS_ENFERMEDADES } from "../../../constantes";
import { CatalogosPlataformaService } from "../../generated/grpc/plataforma_catalogos_pb";
import { MonitoreoPlagaEnfermedadResponse } from "../../response/comun/MonitoreoPlagaEnfermedadResponse";
import { ServiceGetListBase } from "../base/ServiceGetListBase";
import { grpcCall, grpcClient } from "../grpc/grpcCall";

/** Catálogo de plagas y enfermedades de monitoreo (página Monitoreo → Catálogo de plagas). */
export class MonitoreoPlagaEnfermedadService extends ServiceGetListBase<MonitoreoPlagaEnfermedadResponse> {
  static readonly instance = new MonitoreoPlagaEnfermedadService();
  private constructor() { super(); }

  /** Clave única del listado: deduplica `sync()` (dos pedidos simultáneos, un solo request). */
  protected readonly syncKey = SYNC_KEY_CATALOGOS_PLAGAS_ENFERMEDADES;

  /** gRPC-Web (`CatalogosPlataformaService.ListPlagas`): sin eliminados, por grupo y orden. */
  protected async fetchItems(): Promise<MonitoreoPlagaEnfermedadResponse[]> {
    const response = await grpcCall(() => grpcClient(CatalogosPlataformaService).listPlagas({}));
    return response.items.map((p) => ({
      id: p.id,
      isEliminado: false,
      tipoMonitoreo: p.tipoMonitoreo,
      grupo: p.grupo,
      orden: p.orden,
      nombreComun: p.nombreComun,
      nombreTecnico: p.nombreTecnico,
      rangoBajo: p.rangoBajo,
      rangoMedio: p.rangoMedio,
      isCritico: p.isCritico,
      logicaUmbral: p.logicaUmbral,
    }));
  }
}
